/**
 ams-clia version 1:
 key: group
 value: {group, patientRecords:{patientId:doc}}
 
 */
const dbVersion = 5;

// This event is only implemented in recent browsers
function onUpgradeNeeded(event) {
    // Save the IDBDatabase interface
    var db = event.target.result;
    // console.log(`update db from ver${event.oldVersion} to ver${event.newVersion}`);
    if (event.oldVersion >= 1) {
      // if old version >= 1, then the db already exists
      // so we will delete it first then recreate it.
      try {
        db.deleteObjectStore('patientRecords')
      } catch (e) {
        // console.log(e)
      }
      
    }
    // Create an objectStore for this database
    db.createObjectStore("patientSnapshot", { keyPath: "orgId" });
};


export function connect(name,version) {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(name,version);
      request.onupgradeneeded = onUpgradeNeeded
      request.onsuccess = (e)=>{resolve(e.target.result)}
      request.onerror = (e)=>{reject(e.target.error)}
      request.onblocked = (e)=>{
        // console.log('index db blocked')
      }
    })
}


export async function getPatientSnapshot(orgId) {
    const db = await connect('ams-clia',dbVersion)
    const transaction = db.transaction(['patientSnapshot'], 'readwrite')
    const objectStore = transaction.objectStore('patientSnapshot')
    const request = objectStore.get(orgId)
    return new Promise((resolve, reject) => {
      request.onsuccess = (e)=>{
        const result = e.target.result
        if (result) {
          resolve(result)
        } else {
          resolve(null)
        }        
      }
      request.onerror = (e)=>{reject(e.target.error)}
    })
}

/**
 * 
 * @param {{orgId:'orgId of the record',
 *          snapshots:{orgId_0:{...}}},
 *          lastUpdateAt: 'timestamp'
 *        } data 
 * @returns 
 */
export async function savePatientSnapshot(data) {
  const db = await connect('ams-clia',dbVersion)
  const transaction = db.transaction(['patientSnapshot'], 'readwrite')
  const objectStore = transaction.objectStore('patientSnapshot')
  const request = objectStore.put(data)
  return new Promise((resolve, reject) => {
    request.onsuccess = (e)=>{resolve(e.target.result)}
    request.onerror = (e)=>{reject(e.target.error)}
  })
}